/**
 * Detects and ignores errors caused by Chrome Add Ons
 *
 * @param {object} report The report object
 * @returns {boolean} Returns true if the report matches
 */
function chromeAddOnError(report) {
  const restricted = [
    "BetterJsPop",
    "chromeglobalinjectjs",
    "pmddby",
    "magictraps",
    "pingclock",
    "serenityart",
    "promclickapp",
    "protesidenext",
    "pastaleads"
  ];

  return restricted.some(key => {
    if (report.errorMessage.includes(key)) {
      report.ignore();

      return true;
    }

    return false;
  });
}

export default chromeAddOnError;
